import { useState } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../App";

// Pages
import Login from "../pages/Login";
import Dashboard from "../pages/Dashboard";
import Campaigns from "../pages/Campaigns";
import CampaignDetail from "../pages/CampaignDetail";
import Users from "../pages/Users";
import EmailTemplates from "../pages/EmailTemplates";
import TemplateLibrary from "../pages/TemplateLibrary";
import AIStudio from "../pages/AIStudio";
import LandingPages from "../pages/LandingPages";
import Offenders from "../pages/Offenders";
import DepartmentHeatmap from "../pages/DepartmentHeatmap";
import HumanRiskScorecard from "../pages/HumanRiskScorecard";
import InsiderRisk from "../pages/InsiderRisk";
import UserGroups from "../pages/UserGroups";
import Settings from "../pages/Settings";
import Downloads from "../pages/Downloads";
import Media from "../pages/Media";

// Components
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";

// Protected Route
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#fefbff]">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-[#8c3add] border-t-transparent"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

// Main Layout with Sidebar
const MainLayout = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <div className="min-h-screen bg-[#fefbff]">
      <Sidebar collapsed={sidebarCollapsed} onToggle={() => setSidebarCollapsed(!sidebarCollapsed)} />
      <div className={`transition-all duration-300 ${sidebarCollapsed ? "ml-20" : "ml-64"}`}>
        <Header />
        <main className="p-6 lg:p-8">{children}</main>
      </div>
    </div>
  );
};

const PhishingRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <MainLayout>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/campaigns" element={<Campaigns />} />
                <Route path="/campaigns/:id" element={<CampaignDetail />} />
                <Route path="/users" element={<Users />} />
                <Route path="/user-groups" element={<UserGroups />} />
                <Route path="/email-templates" element={<EmailTemplates />} />
                <Route path="/media" element={<Media />} />
                <Route path="/template-library" element={<TemplateLibrary />} />
                <Route path="/ai-studio" element={<AIStudio />} />
                <Route path="/landing-pages" element={<LandingPages />} />
                <Route path="/offenders" element={<Offenders />} />
                <Route path="/department-heatmap" element={<DepartmentHeatmap />} />
                <Route path="/human-risk-scorecard" element={<HumanRiskScorecard />} />
                <Route path="/insider-risk" element={<InsiderRisk />} />
                <Route path="/downloads" element={<Downloads />} />
                <Route path="/settings" element={<Settings />} />
              </Routes>
            </MainLayout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

export default PhishingRoutes;